/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserVoucher,
    UserVoucherFromJSON,
    UserVoucherFromJSONTyped,
    UserVoucherToJSON,
} from './';

/**
 * 
 * @export
 * @interface UserVoucherDataFrame
 */
export interface UserVoucherDataFrame {
    /**
     * 
     * @type {number}
     * @memberof UserVoucherDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof UserVoucherDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof UserVoucherDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<UserVoucher>}
     * @memberof UserVoucherDataFrame
     */
    data: Array<UserVoucher>;
}

export function UserVoucherDataFrameFromJSON(json: any): UserVoucherDataFrame {
    return UserVoucherDataFrameFromJSONTyped(json, false);
}

export function UserVoucherDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserVoucherDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(UserVoucherFromJSON)),
    };
}

export function UserVoucherDataFrameToJSON(value?: UserVoucherDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(UserVoucherToJSON)),
    };
}


